import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React, { PureComponent } from 'react';
import styled from 'styled-components';
import TextField from '../TextField';
import Theme from '../../theme';
import SearchIcon from '../../assets/svgs/search.svg';
import config from './config';
var Container = styled.div.withConfig({
  displayName: "SearchTextField__Container",
  componentId: "sc-qoetgs-0"
})(["position:relative;"]);
var BlackTextField = styled(TextField).withConfig({
  displayName: "SearchTextField__BlackTextField",
  componentId: "sc-qoetgs-1"
})(["&&{padding-right:30px;margin:0;&:focus{border-color:", ";}}"], Theme.colours.black);
var IconContainer = styled.div.withConfig({
  displayName: "SearchTextField__IconContainer",
  componentId: "sc-qoetgs-2"
})(["position:absolute;top:0;right:0;height:100%;display:flex;align-items:center;padding:0 10px;cursor:pointer;"]);
var SearchTextField = /*#__PURE__*/function (_PureComponent) {
  _inheritsLoose(SearchTextField, _PureComponent);
  function SearchTextField() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _PureComponent.call.apply(_PureComponent, [this].concat(args)) || this;
    _this.loadSiteSearch360 = function () {
      var script = document.createElement('script');
      script.type = 'text/javascript';
      window.ss360Config = config;
      script.src = 'https://cdn.sitesearch360.com/sitesearch360-v11.min.js';
      document.getElementsByTagName('head')[0].appendChild(script);
    };
    return _this;
  }
  var _proto = SearchTextField.prototype;
  _proto.componentDidMount = function componentDidMount() {
    if (typeof window.ss360Config === 'undefined') {
      this.loadSiteSearch360();
    } else if (typeof window.SS360 !== 'undefined') {
      window.SS360.init();
    }
  };
  _proto.render = function render() {
    return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(BlackTextField, {
      className: "ss360SearchBox",
      placeholder: "Search"
    }), /*#__PURE__*/React.createElement(IconContainer, {
      size: this.props.iconSize,
      onClick: this.props.onSearchIconClick
    }, /*#__PURE__*/React.createElement(SearchIcon, null)));
  };
  return SearchTextField;
}(PureComponent);
export default SearchTextField;